import React from 'react'

import img1 from '../../imgs/saude-bucal/clareamento/img-1.png'
import img2 from '../../imgs/saude-bucal/clareamento/img-2.png'
import img3 from '../../imgs/saude-bucal/clareamento/img-3.png'
import Carroussel from '../../components/Carroussel'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';


export default function Clareamentos() {
	const cardsData = [
		{
			id: 1,
			image: img1,
		},
		{
			id: 2,
			image: img2,
		},
		{
			id: 3,
			image: img3,
		},
	]
	return (
		<div className='container' style={{ paddingTop: 60, background: 'linear-gradient(to bottom, #ffd5c2, #ffeef0)', paddingBottom: 120 }}>
			<h1 style={{ textAlign: 'center' }}>CLAREAMENTO DENTAL</h1>
			<p style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}><ArrowForwardIcon /> É um procedimento estético que visa remover manchas e clarear a cor dos dentes, melhorando a aparência do sorriso de forma temporária;</p>
			<p style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}><ArrowForwardIcon /> Deve ser sempre realizado com orientação e supervisão de um profissional cirurgião-dentista.</p>
			
			<p style={{ fontWeight: 'bold' }}>Entendemos o interesse pelo clareamento dental, mas esse tipo de tratamento não é oferecido pelo SUS. Se tiver dúvidas, seu dentista pode orientar sobre cuidados com a estética e a saúde bucal.</p>
			<p style={{ fontSize: 28 }} className="atencao"><b>ATENÇÃO:</b></p>
			<p>Produtos como <b>CARVÃO ATIVADO, LIMÃO e BICARBONATO DE SÓDIO <span style={{ color: 'red' }}>NÃO</span></b> devem ser utilizados para clarear os dentes. Essas substâncias são abrasivas, ou seja, funcionam como lixas que causam danos aos seus dentes!<br />
			</p>

			<Carroussel cardsData={cardsData} />
		</div>
	)
};